"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderStatus = void 0;
exports.RenderStatus = {
    Complete: "complete",
    Processing: "processing",
    Failed: "failed",
};
